import { useState } from "react";
import { Globe2 } from "lucide-react";

const PER_CATEGORY = 10;

// Round P — "Geldt overal": general questions (not per site), answered per category + the open list.
export function GeneralCoverage({ general }) {
  if (!general || !Array.isArray(general.per_category) || !general.per_category.length) return null;
  const groups = (general.open || []).reduce((acc, q) => {
    (acc[q.category] = acc[q.category] || []).push(q);
    return acc;
  }, {});
  return (
    <div className="mt-10" data-testid="admin-coverage-general">
      <div className="flex items-center gap-2 mb-3">
        <Globe2 size={14} className="text-tw-yellow" strokeWidth={2.5} />
        <h3 className="font-mono text-[10px] tracking-[0.3em] text-tw-muted uppercase">Geldt overal</h3>
      </div>
      <p className="text-xs text-tw-muted mb-4 max-w-xl leading-relaxed">
        Vragen die voor elke locatie hetzelfde antwoord hebben. Groen is beantwoord.
      </p>
      <div className="mb-5 flex flex-wrap gap-2" data-testid="admin-coverage-general-summary">
        {general.per_category.map((c) => (
          <span key={c.category} data-testid={`admin-coverage-general-chip-${c.category}`}
            className="font-mono text-[10px] uppercase tracking-[0.12em] border border-tw px-2 py-1 text-white">
            {c.category}{" "}
            <span className={c.answered === c.total ? "text-emerald-400" : "text-tw-yellow"}>{c.answered} van {c.total} beantwoord</span>
          </span>
        ))}
      </div>
      {Object.keys(groups).length === 0 ? (
        <p className="font-mono text-[11px] text-emerald-400" data-testid="admin-coverage-general-all-done">Elke algemene vraag heeft een antwoord.</p>
      ) : (
        <div className="grid gap-4" data-testid="admin-coverage-general-open">
          {Object.entries(groups).map(([category, rows]) => <OpenGroup key={category} category={category} rows={rows} />)}
        </div>
      )}
    </div>
  );
}

function OpenGroup({ category, rows }) {
  const [all, setAll] = useState(false);
  const shown = all ? rows : rows.slice(0, PER_CATEGORY);
  return (
    <section className="border border-tw p-3" data-testid={`admin-coverage-general-group-${category}`}>
      <div className="font-mono text-[10px] uppercase tracking-[0.15em] text-tw-muted mb-2">
        {category} · <span className="text-tw-yellow">{rows.length} open</span>
      </div>
      <ul className="grid gap-1.5">
        {shown.map((q) => (
          <li key={q.id} className="text-sm text-white break-words" data-testid={`admin-coverage-general-open-${q.id}`}>
            {q.text}
            {q.functies?.length > 0 && <span className="ml-2 font-mono text-[9px] uppercase tracking-[0.15em] text-tw-muted">{q.functies.join(", ")}</span>}
          </li>
        ))}
      </ul>
      {rows.length > PER_CATEGORY && (
        <button type="button" onClick={() => setAll((v) => !v)} data-testid={`admin-coverage-general-more-${category}`}
          className="tw-press mt-2 font-mono text-[10px] uppercase tracking-[0.15em] text-tw-yellow hover:text-white transition-colors duration-150">
          {all ? "toon minder" : `toon alle ${rows.length}`}
        </button>
      )}
    </section>
  );
}
